// extracted by mini-css-extract-plugin
module.exports = {"toolbar_container":"toolbar_container--aJ46v","left_space":"left_space--f2ile","right_space":"right_space--ccVeA"};